import * as React from 'react';
import useStyles from './StaffLoginInstruction.styles';
import { Icon } from '../../atoms';
import Typography from '../../atoms/Typography/Typography';
import { Trans } from '@lingui/react';
import { useTheme } from 'react-jss';
import { CustomCiamUiTheme } from '../../../theme';
import { useState } from 'react';
import { Auth0Modal } from '../Auth0Modal';

const StaffLoginInstruction: React.FC<{
  currentScreen?: string;
  displayStaffInstruction?: boolean;
  displayProviderLink?: boolean;
}> = ({ currentScreen, displayStaffInstruction, displayProviderLink }) => {
  const theme = useTheme<CustomCiamUiTheme>();
  const classes = useStyles({ theme });
  const [isInstructionOpen, setIsInstructionOpen] = useState(false);
  return (
    <>
      {displayStaffInstruction && (
        <div className={classes.root}>
          <div className={classes.bang}>
            <Icon type="info" />
          </div>
          <div>
            <Typography variant={'body2'} className={classes.titleText}>
              <Trans id="For staff members" />
            </Typography>
            <Typography variant="sub" className={classes.infoText}>
              <Trans
                id="Accounts migrated from the legacy login experience: your username format defaulted to “your doctor’s username+your username”. <0>See example</0>. Ignore this message if you have updated your username to a custom format."
                components={{
                  0: (
                    <a
                      className={classes.link}
                      onClick={() => setIsInstructionOpen(!isInstructionOpen)}
                    />
                  ),
                }}
              />
            </Typography>
          </div>
        </div>
      )}
      {((currentScreen && currentScreen === 'login') ||
        currentScreen === 'reset-password-request') &&
        displayProviderLink && (
          <Typography variant={'body2'} className={classes.providerLink}>
            <Trans
              id={'<0>Become an Invisalign® provider</0>'}
              components={{
                0: (
                  <a
                    className={classes.providerLink}
                    href={'https://www.invisalign.com/provider'}
                  />
                ),
              }}
            />
          </Typography>
        )}
      <Auth0Modal
        isModalOpen={isInstructionOpen}
        modalContent={{
          title: <Trans id="Instructions for staff login" />,
          image:
            'https://ciam-static-files-dv1.auth0.dev.aligntech.com/out/static/img/instructions.png',
          content: (
            <Trans id="For accounts migrated from the legacy login experience:" />
          ),
        }}
        onClose={() => setIsInstructionOpen(false)}
      />
    </>
  );
};

export default StaffLoginInstruction;
